import React from 'react';

import RouteSwitch from '@app/routes/RouteSwitch';
import RouteConfigType from '@app/types/RouteConfigType';

const AutoFilingPage = React.lazy(() => import('@pages/AutoFiling'));
const AutoFilingLogsPage = React.lazy(() => import('@pages/AutoFiling/Logs'));
const BulkDocumentCreationPage = React.lazy(() => import('@pages/BulkDocumentCreation'));
const BulkDocHistoryPage = React.lazy(() => import('@pages/BulkDocumentCreation/History'));
const BulkDocJobDetailPage = React.lazy(() => import('@pages/BulkDocumentCreation/JobDetail'));

const DOCUMENT_MANAGE = 'Document Maintenance';

const documentMaintenanceRoutes: RouteConfigType[] = [
  {
    component: RouteSwitch,
    path: '/document-maintenance',
    title: DOCUMENT_MANAGE,
    exact: false,
    guard: [],
    useInBreadcrumbs: false,
    routes: [
      {
        component: RouteSwitch,
        path: '/document-maintenance/auto-filing-setting',
        title: 'AutoFiling Settings',
        exact: false,
        guard: [],
        useInBreadcrumbs: true,
        routes: [
          {
            component: AutoFilingPage,
            path: '/document-maintenance/auto-filing-setting',
            title: 'AutoFiling Settings',
            exact: true,
            guard: [],
            useInBreadcrumbs: false,
          },
          {
            component: AutoFilingLogsPage,
            path: '/document-maintenance/auto-filing-setting/logs',
            title: 'Logs',
            exact: true,
            guard: [],
            useInBreadcrumbs: false,
          },
        ],
      },
      {
        component: RouteSwitch,
        path: '/document-maintenance/bulk-document-creation',
        title: 'Bulk Document Creation',
        exact: false,
        guard: [],
        useInBreadcrumbs: true,
        routes: [
          {
            component: BulkDocumentCreationPage,
            path: '/document-maintenance/bulk-document-creation',
            title: 'Bulk Document Creation',
            exact: true,
            guard: [],
            useInBreadcrumbs: false,
          },
          {
            component: BulkDocHistoryPage,
            path: '/document-maintenance/bulk-document-creation/history',
            title: 'Run History',
            exact: true,
            guard: [],
            useInBreadcrumbs: false,
          },
          {
            component: BulkDocJobDetailPage,
            path: '/document-maintenance/bulk-document-creation/history/:jobId',
            title: 'Job Detail',
            exact: true,
            guard: [],
            useInBreadcrumbs: false,
          },
        ],
      },
    ],
  },
];
export default documentMaintenanceRoutes;
